module.exports = __webpack_public_path__ + "img/Testachats-sante-logo.eec58603.svg";